import NovaCircle from './NovaCircle';

const BackgroundWrapper = ({ circleTop, circleBottom, children, circleTopColor, circleBottomColor, height }) => {
    return (
        <div style={{position:"relative", zIndex:"0", minHeight:'100vh', display:'flex', flexDirection:'column', backgroundColor: '#eff5f1'}}>
            {circleTop && <NovaCircle size={200} customPosition="top-right" customColor={circleTopColor} />}
            {circleBottom && <NovaCircle size={200} customPosition="bottom-left" customColor={circleBottomColor ? circleBottomColor : '#25763C12'} />}
            {children}
        </div>
    );
};

export default BackgroundWrapper;